import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

import BookCover from '@/app/components/book/card/BookCover.vue'
import { checkCoverFlow_13860 } from '@/services/ab'
import { onMounted, ref } from 'vue'
import { Doc } from '@/models/interfaces'
import { isSafari as _isSafari } from '@/helpers/userAgent'
import { platform } from '@/services/platform'


export default /*#__PURE__*/_defineComponent({
  __name: 'BookCardThumbnail',
  props: {
    doc: null,
    coverClass: null,
    fallbackCoverClass: null,
    cacheBust: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  doc: Doc
  coverClass?: string
  fallbackCoverClass?: string
  cacheBust?: boolean
};



const isSafari = ref(false)

onMounted(async () => {
  checkCoverFlow_13860(props.doc)
  isSafari.value = (await platform.isIOS()) || _isSafari()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["book-thumbnail", { 'book-thumbnail--safari': isSafari.value }])
  }, [
    _createVNode(BookCover, {
      class: "book-thumbnail__cover",
      doc: __props.doc,
      coverClass: __props.coverClass,
      fallbackCoverClass: __props.fallbackCoverClass,
      cacheBust: __props.cacheBust
    }, null, 8, ["doc", "coverClass", "fallbackCoverClass", "cacheBust"]),
    (!isSafari.value)
      ? (_openBlock(), _createBlock(BookCover, {
          key: 0,
          class: "book-thumbnail__cover book-thumbnail__cover--background",
          doc: __props.doc,
          cacheBust: __props.cacheBust
        }, null, 8, ["doc", "cacheBust"]))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})